var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGpt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_27)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.128 5.85272C31.18 5.45812 32.3298 5.40585 33.4133 5.70339L33.872 5.85272L52.5387 12.8527C53.4848 13.2074 54.3106 13.8236 54.9201 14.6295C55.5296 15.4354 55.8976 16.3978 55.9813 17.4047L56 17.8474V32.1487C55.9994 36.4694 54.8325 40.7098 52.6223 44.4224C50.4121 48.135 47.2406 51.1821 43.4427 53.2421L42.7333 53.6154L33.7893 58.0847C33.2971 58.331 32.7592 58.4731 32.2095 58.502C31.6598 58.5309 31.1101 58.446 30.5947 58.2527L30.2107 58.0874L21.2667 53.6127C17.4016 51.6802 14.1301 48.7399 11.7973 45.1024C9.46462 41.4648 8.15728 37.2649 8.01333 32.9461L8 32.1461V17.8501C8.00002 16.8397 8.287 15.8502 8.82756 14.9966C9.36811 14.1431 10.14 13.4606 11.0533 13.0287L11.4613 12.8554L30.128 5.85272ZM29.7147 21.7381L24.4053 30.5861C24.1599 30.9948 24.0273 31.4613 24.0212 31.938C24.015 32.4147 24.1355 32.8845 24.3704 33.2994C24.6052 33.7143 24.946 34.0594 25.3578 34.2995C25.7697 34.5396 26.2379 34.6661 26.7147 34.6661H32.624L29.7147 39.5167C29.3749 40.1217 29.2844 40.8353 29.4622 41.506C29.6401 42.1766 30.0723 42.7516 30.6672 43.1087C31.2621 43.4659 31.9728 43.5771 32.6483 43.4187C33.3239 43.2604 33.9111 42.845 34.2853 42.2607L39.5947 33.4127C39.8401 33.004 39.9727 32.5375 39.9788 32.0608C39.985 31.5841 39.8645 31.1143 39.6296 30.6994C39.3948 30.2845 39.054 29.9393 38.6422 29.6992C38.2303 29.4591 37.7621 29.3327 37.2853 29.3327H31.376L34.288 24.4821C34.6519 23.8752 34.7598 23.1487 34.588 22.4623C34.4162 21.776 33.9788 21.1859 33.372 20.8221C32.7652 20.4582 32.0387 20.3503 31.3523 20.522C30.6659 20.6938 30.0785 21.1312 29.7147 21.7381Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_27"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGpt);
export default __webpack_public_path__ + "static/media/gpt.131d314fb3ed9ea398fce9723eadad5a.svg";
export { ForwardRef as ReactComponent };